import React from 'react';
import * as Material from "@mui/material";
import Text from "@fragments/Text";
import "../styles.scss";

const ChoicesInput = ({
    multiple = false,
    options = [],
    value,
    onInput,
    disabled = false,
    className = '',
    name,
    ...props
}) => {

    const handleSelect = (optionValue) => {
        if (disabled) return;

        if (multiple) {
            const currentValues = Array.isArray(value) ? value : [];
            const isSelected = currentValues.includes(optionValue);
            let newValues;

            if (isSelected) {
                newValues = currentValues.filter(v => v !== optionValue);
            } else {
                newValues = [...currentValues, optionValue];
            }
            onInput(newValues);
        } else {
            // For single selection, if it's already selected, usually we don't deselect in radio behavior,
            // but we just set the new value.
            onInput(optionValue);
        }
    };

    const isSelected = (optionValue) => {
        if (multiple) {
            return Array.isArray(value) && value.includes(optionValue);
        }
        return value === optionValue;
    };

    return (
        <div className={`CustomInput_choices ${className}`.trim()} {...props}>
            {options.map((option, index) => {
                const selected = isSelected(option.value);
                const ControlComponent = multiple ? Material.Checkbox : Material.Radio;

                return (
                    <div
                        key={option.value || index}
                        className={`choice-item ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                        onClick={() => handleSelect(option.value)}
                    >
                        <div className="choice-control">
                            <ControlComponent
                                checked={selected}
                                disabled={disabled}
                                color="secondary"
                                style={{
                                    transform: "translateY(-1px)"
                                }}
                                size='small'
                                name={name}
                                inputProps={{ 'aria-label': typeof option.label === 'string' ? option.label : undefined }}
                                // Prevent double toggle if clicking the input itself propagates to div
                                onClick={(e) => e.stopPropagation()}
                                onChange={() => handleSelect(option.value)}
                            />
                        </div>
                        {option.left && (
                            <div className="choice-left" style={{
                                transform: "translateY(-2px)"
                            }}>
                                {option.left}
                            </div>
                        )}
                        <div className="choice-content">
                            <Text.h5 value={option.label} style={{ marginTop: "3px" }} />
                            {option.description && (
                                <Text.span
                                    value={option.description}
                                    contrast={5}
                                    style={{
                                        marginTop: '-3px'
                                    }}
                                />
                            )}
                        </div>
                        {option.right && (
                            <div className="choice-right" style={{
                                transform: "translateY(-2px)"
                            }}>
                                {option.right}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ChoicesInput;
